import React, { useState } from 'react';
import {
  StatusBar, SafeAreaView, View, StyleSheet, ActivityIndicator, Text, Image,
} from 'react-native';
import { TextInput } from 'react-native-paper';
import { useDispatch, useSelector } from 'react-redux';
import userActions from '../actions/userActions';
import GradientButton from '../components/GradientButton';
import Header from '../components/Header';
import StatusTypes from '../store/types';
import APMStyles from '../styles';
import Theme from '../constants/Theme';

const bannerImg = require('../assets/images/glitchlogo.gif');

function Register({ navigation }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const status = useSelector((state) => state.user.status);
  const regError = useSelector((state) => state.user.error);

  const dispatch = useDispatch();

  function register() {
    if (email && password && password2 && password === password2) {
      dispatch(userActions.register({ email, password }));
    }
  }

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar barStyle="dark-content" />
      <Header backButton style={styles.header} navigation={navigation} />

      <View style={styles.body}>
        <View style={styles.banner}>
          <Image source={bannerImg} style={styles.image} resizeMode="center" />
        </View>

        <View style={styles.form}>
          {status === StatusTypes.registerFail && (
          <Text testID="register-error-msg" style={styles.status}>
            Registration failed:
            {' '}
            {regError.message}
          </Text>
          )}
          {status === StatusTypes.registerPending && <ActivityIndicator testID="loading-indicator" />}
          {status === StatusTypes.registerSuccess && <Text testID="register-success-msg" style={styles.status}>Registration success. Please confirm your email.</Text>}

          <View>
            <TextInput
              label="EMAIL"
              value={email}
              onChangeText={(text) => setEmail(text)}
              testID="register-email-input"
              theme={Theme.textInput}
              mode="outlined"
              left={<TextInput.Icon name="email-outline" />}
              style={styles.textInput}
            />

            <TextInput
              secureTextEntry
              label="PASSWORD"
              value={password}
              onChangeText={(text) => setPassword(text)}
              testID="register-password-input"
              theme={Theme.textInput}
              mode="outlined"
              left={<TextInput.Icon name="lock-outline" />}
              style={styles.textInput}
            />

            <TextInput
              secureTextEntry
              label="CONFIRM PASSWORD"
              value={password2}
              onChangeText={(text) => setPassword2(text)}
              testID="register-password2-input"
              theme={Theme.textInput}
              mode="outlined"
              left={<TextInput.Icon name="lock" />}
              style={styles.textInput}
            />
          </View>

          <GradientButton
            onPress={register}
            disabled={!email || !password || !password2 || password !== password2
              || status === StatusTypes.registerPending}
            testID="register-submit-btn"
            style={styles.button}
          >
            REGISTER
          </GradientButton>
        </View>
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: APMStyles.colors.background,
  },
  header: {
    flex: 1,
  },
  body: {
    flex: 11,
    justifyContent: 'center',
    paddingHorizontal: '20%',
  },
  banner: {
    flex: 1,
    marginTop: 5,
  },
  image: {
    flex: 1,
  },
  form: {
    flex: 2,
  },
  status: {
    color: APMStyles.colors.text,
  },
  textInput: {
    paddingBottom: 10,
  },
  button: {
    marginTop: 6,
    paddingBottom: 10,
  },
});

export default Register;
